module.exports = __webpack_public_path__ + "static/img/TO.97b1a581.png";